import React, { useState } from 'react'
import Header from '../Layouts/Header'
import bgImage from '../Assets/Images/10740576.jpg';
import { MdKeyboardArrowDown } from "react-icons/md";
import { FaArrowDown } from "react-icons/fa";
import CircularText from '../Components/CircularText';
import Footer from '../Layouts/Footer';

const faqs = [
  {
    question: "Which is the best software development company in Madurai?",
    answer:
      "Vivekasoftek is widely recognized as one of the best software development companies in Madurai. We deliver high-quality, tailor-made software solutions for startups, SMEs, and enterprises. With an expert team and customer-first approach, we ensure each project is innovative, scalable, and business-driven.",
  },
  {
    question: "Does Vivekasoftek provide web development services in Madurai?",
    answer:
      "Yes, we provide full-stack web development services in Madurai. Our team builds responsive, secure, and high-performing websites, e-commerce platforms, and enterprise-level web applications. We use modern technologies and frameworks to ensure your business stands out online.",
  },
  {
    question: "Can Vivekasoftek develop mobile applications?",
    answer:
      "Absolutely! Vivekasoftek is a leading mobile app development company in Madurai. We create feature-rich Android and iOS apps that are fast, user-friendly, and designed to deliver seamless digital experiences. From concept to deployment, we handle the complete app lifecycle.",
  },
  {
    question: "Does Vivekasoftek offer digital marketing services?",
    answer:
      "Yes, our digital marketing team helps businesses grow their brand visibility and online sales. We offer SEO, social media marketing, Google Ads, and content marketing services in Madurai. Our strategies are data-driven, ROI-focused, and customized for your target audience.",
  },
  {
    question: "Do you provide corporate training programs?",
    answer:
      "Yes, Vivekasoftek conducts specialized corporate training programs for IT professionals. Our training modules include the latest programming languages, frameworks, and project management tools. These programs are designed to upskill your workforce and improve overall team productivity.",
  },
  {
    question: "Does Vivekasoftek provide IT staff services?",
    answer:
       "Yes, we offer IT staff servicesto help businesses scale faster. Whether you need developers, testers, or digital marketing experts, we provide skilled professionals who work as an extended part of your team. This ensures flexibility, reduced hiring costs, and faster project execution.",
  },
  {
    question: "What kind of custom software solutions does Vivekasoftek provide?",
    answer:
      "We specialize in developing custom software solutions such as ERP systems, CRM applications, HR management platforms, and billing solutions. Each software is built from scratch, tailored to your unique business processes, ensuring efficiency, automation, and growth.",
  },
  {
    question: "How does Vivekasoftek stand among Tamil Nadu software companies?",
    answer:
      "Vivekasoftek is among the fastest-growing software companies in Tamil Nadu. With a strong presence in Madurai and clients across India, we focus on innovation, technology, and long-term customer partnerships. Our reputation is built on delivering quality, trust, and sustainable IT solutions.",
  },
];


const AccordionItem = ({ faq, isOpen, onClick }) => {
  return (
    <div className="border-b">
      <button
        onClick={onClick}
        className="w-full text-left flex justify-between items-center py-3 px-4 md:py-4 md:px-6 focus:outline-none"
      >
        <span className="text-sm md:text-lg font-semibold">{faq.question}</span>
        <span
          className={`transform transition-transform duration-300 ${
            isOpen ? "rotate-180" : "rotate-0"
          }`}
        >
          <MdKeyboardArrowDown className="text-xl md:text-2xl" />
        </span>
      </button>
      <div
        className={`px-4 md:px-6 overflow-hidden transition-all duration-500 ease-in-out ${
          isOpen ? "max-h-40 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <p className="text-gray-600 pb-3 md:pb-4 text-sm md:text-base font-medium">
          {faq.answer}
        </p>
      </div>
    </div>
  );
};

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const handleScroll = () => {
    const section = document.getElementById('scrollDown');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <Header />

      {/* Hero Section */}
      <div
        className="relative h-[80vh] md:h-screen flex items-center justify-center text-white"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
        }}
      >
        <div className="absolute inset-0 bg-black opacity-55"></div>

        <div className="relative z-10 flex flex-col items-center justify-center text-center space-y-16 md:space-y-24 px-4">
          <h1 className="text-2xl sm:text-3xl md:text-6xl font-bold leading-snug">
            Frequently Asked Questions
          </h1>

          <div className="relative w-20 h-20 md:w-28 md:h-28 flex items-center justify-center">
            <div
              onClick={handleScroll}
              className="absolute inset-0 flex items-center justify-center cursor-pointer"
            >
              <CircularText
                text="VIVEKASOFTEK @ EXPLORE  "
                spinDuration={20}
              />
            </div>

            <button
              onClick={handleScroll}
              className="z-10 flex items-center justify-center"
            >
              <FaArrowDown size={40} className=" text-white" />
            </button>
          </div>
        </div>
      </div>

      {/* FAQ Section */}
      <section
        id="scrollDown"
        className="bg-white py-12 md:py-20 px-4 sm:px-6 md:px-20 flex justify-center"
      >
        <div className="max-w-4xl w-full">
          <h2 className="text-2xl sm:text-3xl font-bold text-center mb-6 md:mb-10 text-gray-800">
            Explore Our FAQ
          </h2>
          <div className="bg-white rounded-xl shadow-lg divide-y">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                faq={faq}
                isOpen={openIndex === index}
                onClick={() =>
                  setOpenIndex(openIndex === index ? null : index)
                }
              />
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Faq;